'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RadioInput = require('../../../../components/form/fields/RadioInput');

var _RadioInput2 = _interopRequireDefault(_RadioInput);

var _Spinner = require('../../../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _paymentConstants = require('../../../../../common/payment/paymentConstants');

var _paymentUtil = require('../../../../../common/payment/paymentUtil');

var _currencyUtil = require('../../../../../common/payment/currencyUtil');

require('./PaymentPlanList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PaymentPlan = function PaymentPlan(_ref) {
    var plan = _ref.plan,
        planVolume = _ref.planVolume,
        props = _objectWithoutProperties(_ref, ['plan', 'planVolume']);

    var period = plan.get('interval');
    var price = (0, _paymentUtil.centsToDollars)(plan.get('amount') * planVolume);
    var priceMonthly = (0, _paymentUtil.convertPriceUnits)(price, period, _paymentConstants.PRICE_BILLING_UNITS.month);
    var currency = (0, _currencyUtil.getCurrencySymbol)(plan.get('currency'));
    var savePercent = plan.getIn(['metadata', 'save_percent']);

    return _react2.default.createElement(
        'div',
        { className: 'field-row' },
        _react2.default.createElement(
            'div',
            { className: 'field' },
            _react2.default.createElement(
                'label',
                { className: 'plan' },
                _react2.default.createElement(_RadioInput2.default, _extends({}, props, {
                    name: 'plan',
                    value: period,
                    type: 'radio',
                    className: 'radio' })),
                _react2.default.createElement(
                    'span',
                    { className: 'describe' },
                    'Billed ',
                    period + 'ly',
                    savePercent ? _react2.default.createElement(
                        'span',
                        { className: 'save' },
                        ' (save ',
                        savePercent,
                        '%)'
                    ) : null
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'price' },
                    currency,
                    priceMonthly,
                    ' / month'
                )
            )
        )
    );
};

PaymentPlan.propTypes = {
    plan: _propTypes2.default.object,
    planVolume: _propTypes2.default.number
};

var PaymentPlanList = function PaymentPlanList(props) {
    var plans = props.plans;


    if (!plans) {
        return _react2.default.createElement(
            'div',
            { className: 'PaymentPlanList' },
            _react2.default.createElement(_Spinner2.default, { show: true })
        );
    }

    var plansOrdered = plans.sort(function (a, b) {
        return (0, _paymentUtil.convertPriceUnits)(a.get('amount'), a.get('interval'), _paymentConstants.PRICE_BILLING_UNITS.month) - (0, _paymentUtil.convertPriceUnits)(b.get('amount'), b.get('interval'), _paymentConstants.PRICE_BILLING_UNITS.month);
    });

    return _react2.default.createElement(
        'div',
        { className: 'PaymentPlanList' },
        plansOrdered.map(function (plan) {
            return _react2.default.createElement(PaymentPlan, _extends({}, props, { plan: plan, key: plan.get('id') }));
        })
    );
};

PaymentPlanList.propTypes = {
    plans: _propTypes2.default.object
};

exports.default = PaymentPlanList;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/form/PaymentPlanList.js
// module id = 2060
// module chunks = 0